// extracted by mini-css-extract-plugin
export var header = "_ga-0";